import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { savingsConfig } from '../../../environments/environment';
import { LoginService } from '../../service/login.service';

@Component({
    selector: 'app-saving',
    template: ''
})
export class SavingComponent implements OnInit {
  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute
  ) {
    this.route.url.subscribe((segments) => {
      let native = segments.some((seg) => seg.path === 'native');
      this.route.queryParams.subscribe(async (params) => {
        const inApp = params['inApp'];
        const product = params['product'];
        const banner = params['banner'];
        let channel = params['channel'];

        const tenanthost = params['tenanthost'];
        if (tenanthost === 'eb') {
          channel = 'ebanking';
        } else {
          channel = 'app';
        }

        if (savingsConfig.redirectUri) {
          // Handle native path
          if (native) {
            savingsConfig.redirectUri += '/native';
          }

          // Build query parameters
          const queryParams = [];

          if (banner) {
            queryParams.push('banner=' + banner);
          }

          if (channel) {
            queryParams.push('channel=' + channel);
          }

          if (inApp) {
            queryParams.push('inApp=true');
          }

          if (product) {
            queryParams.push('product=' + product);
          }

          // Append query parameters if any exist
          if (queryParams.length > 0) {
            const separator = savingsConfig.redirectUri.includes('?') ? '&' : '?';
            savingsConfig.redirectUri += separator + queryParams.join('&');
          }
        }
      });
    });
  }

  ngOnInit(): void {
    this.loginService.login(savingsConfig);
  }
}
